import React from 'react';
import Loadable from 'react-loadable';

import FirstLoader from '../FirstLoader/FirstLoader';

const LoadableManageCurrenciesWizard = Loadable({
  loader: () => import(/* webpackChunkName: "ManageCurrencies" */ './ManageCurrenciesWizard'),
  modules: ['./ManageCurrencies'],
  loading: () => <FirstLoader />
});

export default LoadableManageCurrenciesWizard;
